module.exports = __webpack_public_path__ + "img/stop_btn.e42be00f.png";